export default __webpack_public_path__ + "static/media/CL06.45efb152.mp3";